var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindMoon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18C2.25 17.5858 2.58579 17.25 3 17.25H8.5C9.74264 17.25 10.75 18.2574 10.75 19.5C10.75 20.7426 9.74264 21.75 8.5 21.75H7C6.58579 21.75 6.25 21.4142 6.25 21C6.25 20.5858 6.58579 20.25 7 20.25H8.5C8.91421 20.25 9.25 19.9142 9.25 19.5C9.25 19.0858 8.91421 18.75 8.5 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.5C14.25 20.8472 16.1528 22.75 18.5 22.75C20.8472 22.75 22.75 20.8472 22.75 18.5C22.75 16.1528 20.8472 14.25 18.5 14.25H4C3.58579 14.25 3.25 14.5858 3.25 15C3.25 15.4142 3.58579 15.75 4 15.75H18.5C20.0188 15.75 21.25 16.9812 21.25 18.5C21.25 20.0188 20.0188 21.25 18.5 21.25C16.9812 21.25 15.75 20.0188 15.75 18.5V18C15.75 17.5858 15.4142 17.25 15 17.25C14.5858 17.25 14.25 17.5858 14.25 18V18.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9058 13.8667C20.9525 13.1648 19.7747 12.75 18.5 12.75H4C3.59561 12.75 3.21614 12.8567 2.88819 13.0434C2.32148 11.9882 2 10.7816 2 9.5C2 5.35786 5.35786 2 9.5 2C13.5175 2 16.7973 5.15887 16.991 9.12836C17.3133 9.04459 17.6514 9 18 9C20.2091 9 22 10.7909 22 13C22 13.2976 21.9675 13.5877 21.9058 13.8667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindMoon1);
export default __webpack_public_path__ + "static/media/wind-moon-1.c6f4f7e69fe14900639906092d04ccab.svg";
export { ForwardRef as ReactComponent };